import { render, staticRenderFns } from "./BroadcastMessageMenu.vue?vue&type=template&id=617b1ebe&scoped=true&"
import script from "./BroadcastMessageMenu.vue?vue&type=script&lang=js&"
export * from "./BroadcastMessageMenu.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastMessageMenu.vue?vue&type=style&index=0&id=617b1ebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617b1ebe",
  null
  
)

export default component.exports